import {ProductsDict, getTeaserPrices} from '../services/products';

/**
 * Class used as a controller for products grid showcase directive.
 */
export default class ProductsShowcase {
    productType: string;
    products: any[];
    apiPromise: Promise<ProductsDict | void> | void;

    constructor(
        $scope,
        private $location,
        private broker: Core.Broker,
    ) {
        if (Array.isArray(this.products) && this.products.length > 0) {
            this.products.forEach(item => {
                item.DomainId = TRPCONFIG.Domain.DomainId;
                item.Currency = TRPCONFIG.Domain.CurrencyCode;
            });
            this.apiPromise = getTeaserPrices(this.productType, this.products);
            if (this.apiPromise != null) {
                this.apiPromise.then(res => {
                    $scope.$apply();
                    return res;
                });
            }
        }

        if (this.productType === 'attraction') {
            this.publishAttractionsNewPerson();
        }
    }

    publishAttractionsNewPerson() {
        const area: string = 'attractions';
        const currentPath: string = this.$location.path().substring(1);
        const title: string[] = currentPath.split('/');

        title.push((currentPath === area && 'homepage') || 'Destination');
    }

    getTeaserPrices() {
        return this.apiPromise;
    }
}

angular
    .module('TR')
    .directive('productsGridShowcase', (): ng.IDirective => ({
        restrict: 'E',
        replace: true,
        scope: {},
        bindToController: {
            productType: '@',
            products: '='
        },
        controller: ['$scope', '$location', 'broker', ProductsShowcase],
        controllerAs: 'ProductsShowcase'
    }));

